//#region src/root.ts
/** Stable identifier used for the root route in a route tree. */
var rootRouteId = "__root__";
//#endregion
export { rootRouteId };

//# sourceMappingURL=root.js.map